<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">PEDIDOS DE ASISTENCIA</h4>
            <div class="small text-muted">Crear y administrar todos los pedidos emitidos y recibidos</div>
          </b-col>

          <b-col sm="5">
            <b-button @click="$router.push({ name: 'ReclamosStaffDashboard' })" type="button" variant="outline-dark" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Volver al Dashboard">
              <i class="fa fa-arrow-left"></i> Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <iframe
          :src="iframeSrc"
          style="width: 100%; height: 800px; border: none;"
          frameborder="0">
        </iframe>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.RECLAMOS,
          profile_id: Profiles.PERSONAL,
          view_reference: '211.Pedidos de Asistencia',
          elements: {}
        },
      }
    },
    computed: {
      iframeSrc() {
        return this.$route.query.src || 'https://app.tables.com.ar/backend/public/php/interface/slug/34-reclamos?es_admin=true&status='
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
  }
</script>

<style>

</style>
